<template>
    <Form label-position="top" :model="companyCode" ref="formValidate" style="padding-bottom: 40px;" :class="isSearch ? '' : 'allCode'">
        <div>
            <FormItem label="Company code" prop="company_code" style="margin-bottom: 20px;">
                <Select v-model="companyCode.company_code" placeholder="Select Company code" filterable :clearable="true" class="max400 w400" v-if="userInfo.role!='COMPANY' && userInfo.role!='SITE'">
                    <Option v-for="(item, index) in Company" :value="item.value" :key="index" >{{ item.label }}</Option>
                </Select>
                <Input v-model="companyCode.company_code" v-else :disabled="userInfo.role=='COMPANY' || userInfo.role=='SITE'" class="w400"></Input>
            </FormItem>
        </div>
        <div>
            <FormItem label="Major code" prop="major_code" style="margin-bottom: 20px;">
                <Select v-model="companyCode.major_code" placeholder="Select Major code" filterable :clearable="true"  class="max400 w400" v-if="userInfo.role != 'SITE'">
                    <Option v-for="(item, index) in Major" :value="item.value" :key="index" >{{ item.label }}</Option>
                </Select>
                <Input v-model="companyCode.major_code" v-else :disabled="userInfo.role=='SITE'" class="w400"></Input>
            </FormItem>
            <FormItem label="Minor code" prop="minor_code" style="margin-bottom: 20px;">
                <Select v-model="companyCode.minor_code" placeholder="Select Minor code" filterable :clearable="true"  class="max400 w400" v-if="userInfo.role != 'SITE'">
                    <Option v-for="(item, index) in Minor" :value="item.value" :key="index">{{ item.label }}</Option>
                </Select>
                <Input v-model="companyCode.minor_code" v-else :disabled="userInfo.role=='SITE'" class="w400"></Input>
            </FormItem>
            <FormItem label="Sub code" prop="sub_code" style="margin-bottom: 20px;">
                <Select v-model="companyCode.sub_code" placeholder="Select Sub code" filterable :clearable="true"  class="max400 w400" v-if="userInfo.role != 'SITE'">
                    <Option v-for="(item, index) in Sub" :value="item.value" :key="index">{{ item.label }}</Option>
                </Select>
                <Input v-model="companyCode.sub_code" v-else :disabled="userInfo.role=='SITE'" class="w400"></Input>
            </FormItem>
            <FormItem label="Site/Location code" prop="site_code" style="margin-bottom: 20px;">
                <Select v-model="site_code" placeholder="Select Site/Location code" filterable :clearable="true" v-if="!isSiteAdd && userInfo.role != 'SITE'"  class="max400">
                    <Option v-for="(item, index) in SiteCode" :value="item.value" :key="index">{{ item.label }}</Option>
                </Select>
                <Input v-model="site_code" placeholder="Site/Location code" v-else :disabled="userInfo.role=='SITE'" class="w400"></Input>
            </FormItem>
        </div>
    </Form>
</template>

<script>
    import { mapState } from 'vuex';
    import { site, menu, companyConfiguration} from '@/api';
    import { Lodash } from '@/utils';

    export default {
        props: {
            detailId: [String, Number],
            isSearch: {
                type: Boolean,
                default: false
            },
            isSiteAdd: {
                type: Boolean,
                default: false
            },
            companyCodes: {
                type: Object,
                default: null
            },
            readonly: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                companyCode: {
                    company_code: '',
                    major_code: '',
                    minor_code: '',
                    sub_code: '',
                },
                site_code: '',
                Major: [],
                Minor: [],
                Sub: [],
                SiteCode: [],
                Company: [],
                MinorParentCode: '',
                SubParentCode: '',
                ruleValidate: {
                    company_code: [ {required: false, message: 'Please select Company code ', trigger: 'change'} ],
                    major_code: [ {required: false, message: 'Please select Major code ', trigger: 'change'} ],
                    minor_code: [ {required: false, message: 'Please select Minor code ', trigger: 'change'} ],
                    sub_code: [ {required: false, message: 'Please select Sub code ', trigger: 'change'} ],
                    site_code: [ {required: false, message: 'Please select Site/Location code ', trigger: 'change'} ]
                }
            }
        },
        computed: {
            ...mapState('common', ['company_code', 'userInfo']),
        },
        watch: {
            companyCode: {
                handler(val, oldVal) {
                    const old = Object.assign({}, this.companyCodes);
                    delete old.site_code;
                    const arr = [];
                    for(const key in val) {
                        if(val[key]) arr.push(key);
                    }
//                    if(val && ((arr.length >= 4 && this.userInfo.role==='SYSTEM') || (arr.length >= 3 && this.userInfo.role!=='SYSTEM'))) {
//
//                    }
                    if(val.company_code) {
                        if(!Lodash.isEqual(val, old)) this.site_code = '';
                        if(this.userInfo.role=='SITE') this.site_code = this.userInfo.site_code;
                        this.getSiteList();
                    }
                },
                deep: true
            }
        },
        mounted() {
            // SITE character information is backfilled, all code editing is prohibited
            if(this.userInfo.role=='SITE') {
                for(const key in this.companyCode) {
                    this.companyCode[key] = this.userInfo[key];
                }
                this.site_code = this.userInfo.site_code;
                return;
            }
            this.allGet()
                .then((bool) => {
                    if(bool && this.companyCodes) {
                        for(const key in this.companyCode) {
                            this.companyCode[key] = this.companyCodes[key];
                        }
                        // COMPANY role company_code is backfilled, editing is prohibited
                        if(this.userInfo.role=='COMPANY') this.companyCode.company_code = this.userInfo.company_code;
                        this.site_code = this.companyCodes.site_code;
                    }
                })
        },

        methods: {
            async allGet() {
                await this.getCompanyList();
                await this.getValidSiteCode('Major');
                await this.getValidSiteCode('Minor');
                await this.getValidSiteCode('Sub');
                return Promise.resolve(true);
            },
            validateCallback() {
                const params = Object.assign({}, this.companyCode);
                params.site_code = this.site_code;
                this.$emit('success', params);
            },
            async getCompanyList() {
                try {
                    let { data } = await companyConfiguration.getList({
                        company_code: this.userInfo.company_code
                    });
                    this.Company = data.list.map(val => {
                        return {
                            value: val.code,
                            label: val.code
                        }
                    })
                } catch (e) {
                    throw new Error(e);
                }
            },
            async getValidSiteCode(type) {
                try {
                    const { data } = await site.getValidSiteCode({
                        company_code: this.company_code,
                        type: type.toUpperCase()
                    });
                    this[type] = data.map(val => {
                        return {
                            value: val.id,
                            label: val.code
                        }
                    })
                } catch (e) {
                    throw new Error(e);
                }
            },
            async getSiteList() {
                const params = Object.assign({}, this.companyCode);
                delete params.site_code;
                try {
                    const { data } = await site.getSiteList(params);
                    this.SiteCode = data.list.map(val => {
                        return {
                            value: val.id,
                            label: val.site_code
                        }
                    })
                } catch (e) {
                    throw new Error(e);
                }
            },
        }
    }
</script>
<style scoped>
    .max400 {
        max-width: 400px;
    }
</style>
<style lang=scss>
    .allCode {
        .w400 {
            .ivu-input {
                max-width: 400px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/components/MajorMinorSubCode.vue